/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Editor_RegionInputs */

const en_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const de_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const fr_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const es_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const it_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regione`)
};

const nl_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regio`)
};

const pl_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const fi_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alue`)
};

const da_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

const sv_resume_editor_region = /** @type {(inputs: Resume_Editor_RegionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Region`)
};

/**
* | output |
* | --- |
* | "Region" |
*
* @param {Resume_Editor_RegionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resume_editor_region = /** @type {((inputs?: Resume_Editor_RegionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Editor_RegionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resume_editor_region(inputs)
	if (locale === "fr") return fr_resume_editor_region(inputs)
	if (locale === "es") return es_resume_editor_region(inputs)
	if (locale === "it") return it_resume_editor_region(inputs)
	if (locale === "nl") return nl_resume_editor_region(inputs)
	if (locale === "pl") return pl_resume_editor_region(inputs)
	if (locale === "fi") return fi_resume_editor_region(inputs)
	if (locale === "da") return da_resume_editor_region(inputs)
	if (locale === "sv") return sv_resume_editor_region(inputs)
	return en_resume_editor_region(inputs)
});